<div
  class="flex w-full rounded-xl bg-[#FCEEEF] px-6 py-4 font-lato text-sm font-semibold text-[#D11314]"
  [ngClass]="{
    'bg-[#FCEEEF] text-[#D11314]': status == 'warning',
    'bg-[#F4FCF3] text-[#1E8500]': status == 'success',
  }"
>
  {{ message }}
</div>
